import { IconX } from '@tabler/icons-react'
import React from 'react'
import { formatDate } from '../Utils/helpers/commonhelper'

export const FilterQueryString = ({
    filterValues,
    setCurrAdvFilter,
    setTempFilterData,
    setFilterState,
    setFilterValues,
}) => {

    const fetchFilterIdLabel = (value, options) => {
        const data = options.find(c => c.value === value)
        return data?.label
    }

    const getFilterValueQueryString = () => {
        if (!filterValues?.length) return []

        return filterValues.map((filter) => ({
            id: filter.id,
            type: filter.type,
            field: filter.label_name,
            operator: filter.subFilterType || filter.subFilterQuery,
            value: filter?.option?.length > 0
                ? fetchFilterIdLabel(filter.value, filter.option)
                : filter.value,
        }))
    }

    const handleUpdateFilterQuery = (id) => {
        const updatedFilterValues = filterValues?.filter(c => c.id !== id)
        const applyData = []
        updatedFilterValues.map((f) => {
            const data = {
                label_name: f.field,
                label_query: f.subFilterType,
                label_value:
                    f.subFilterType === "between"
                        ? { start: f.value?.start, end: f.value?.end }
                        : f.value,
            }
            applyData.push(data)
        })

        if (updatedFilterValues.length === 0) {
            setCurrAdvFilter(null)
            setTempFilterData(null)
        }
        setFilterState(updatedFilterValues)
        setFilterValues({
            filter_values: applyData,
            filter_state: updatedFilterValues
        })
    }
    return (
        <>
            {filterValues?.length > 0 && (
                <div
                    className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-2"
                    style={{ paddingRight: "3px" }}
                    aria-label="Applied filters"
                >
                    <span
                        style={{
                            color: "#64748b",
                            fontSize: "11px",
                            fontWeight: 700,
                            letterSpacing: "0.04em",
                        }}
                    >
                        Applied filters
                    </span>
                    {getFilterValueQueryString().map((filter, index) => (
                        <div className="d-flex align-items-center gap-2" key={`${filter.id}`}>
                            {index > 0 && (
                                <span
                                    style={{
                                        color: "#94a3b8",
                                        fontSize: "11px",
                                        fontWeight: 700,
                                        textTransform: "uppercase",
                                    }}
                                >
                                    And
                                </span>
                            )}
                            <span
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    padding: "6px 10px",
                                    border: "1px solid #dbeafe",
                                    borderRadius: "999px",
                                    background: "#f8fbff",
                                    color: "#334155",
                                    fontSize: "13px",
                                    lineHeight: 1.2,
                                    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
                                }}
                            >
                                <strong style={{ color: "#1d4ed8", fontWeight: 600, fontSize: '11px' }}>{filter.field}</strong>
                                <span style={{ color: "#64748b", fontSize: '11px' }}>{filter.operator}</span>
                                <span style={{ color: "#0f172a", fontWeight: 600, fontSize: '11px' }}>{filter?.type === "date-range" ? `${formatDate(filter.value.start)} - ${formatDate(filter.value.end)}` : filter.value || "—"}</span>
                                <button
                                    style={{ border: 'none', background: 'transparent' }}
                                    type="button"
                                    onClick={() => handleUpdateFilterQuery(filter?.id)}>
                                    <IconX size={12} color="red" cursor={'pointer'} />
                                </button>
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}
